import React from 'react';
import * as Ons from 'react-onsenui';
import { translate as _ } from '../util/i18n';
import useIOSInstallPrompt from '../hooks/useIOSInstallPrompt';
import useWebInstallPrompt from '../hooks/useWebInstallPrompt';
import logo from '../../img/logos/dp-logo.png';

export const PWAInstaller = () => {

    const [ iOSInstallPrompt, handleIOSInstallDeclined                           ] = useIOSInstallPrompt();
    const [ webInstallPrompt, handleWebInstallDeclined, handleWebInstallAccepted ] = useWebInstallPrompt();

    // console.log( 'components.PAWInstaller -> iOSInstallPrompt, webInstallPrompt', iOSInstallPrompt, webInstallPrompt );

    if ( ! iOSInstallPrompt && ! webInstallPrompt ) {

        return null;

    }

    return (

        <Ons.Toast isOpen className="pwa-installer">

            <div className="logo"><img src={logo} alt="Logo" /></div>

            <h4>{_( 'App installieren' )}</h4>

            <div className="install">

                {

                    iOSInstallPrompt ?

                        <>
                            <p className="instructions">{_( 'Tippe auf' )} <Ons.Icon icon='ion-ios-share'></Ons.Icon> {_( 'und "Zum Home-Bildschirm"' )}</p>
                            <p><Ons.Button onClick={handleIOSInstallDeclined} modifier="outline">{_( 'Schließen' )}</Ons.Button></p>
                        </>

                    : webInstallPrompt &&

                        <>
                            <Ons.Button onClick={handleWebInstallAccepted}>{_( 'Installieren' )}</Ons.Button>
                            &nbsp;
                            <Ons.Button onClick={handleWebInstallDeclined} modifier="outline">{_( 'Schließen' )}</Ons.Button>
                        </>

                }

            </div>

            <p className="hint">
                <Ons.Icon icon='ion-ios-information-circle, material:md-information'></Ons.Icon>
                {_( 'Nach dem Installieren der App kann diese vom Home-Bildschirm im Vollbildmodus gestartet werden.' )}
            </p>

        </Ons.Toast>

    );

};

export default PWAInstaller;